import { configureStore } from '@reduxjs/toolkit';
import { generalSlices } from './reducers/generalSlices';
import { sessionSlices } from './reducers/sessionSlices';

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    general: generalSlices.reducer,
    session: sessionSlices.reducer,
  },
});

// export type AppDispatch = typeof store.dispatch;
